const getDateAsString = (isoDate) => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    timeZone: userTimezone,
  };

  const date = new Date(isoDate);
  const formattedDate = date.toLocaleString("en-US", options);
  return formattedDate;
};

export { getDateAsString };
